// TODO Remove once translations feature is released
export function isI18nFeatureEnabled(): boolean {
  if (globalThis.window === undefined || globalThis.localStorage === undefined) {
    return false;
  }
  return !!globalThis.localStorage.getItem('backstage.feature-i18n.enabled');
}
